import { createContext, useContext, useMemo, useState } from "react";

const ActiveEquipmentCategoryContext = createContext({
  activeCategory: null,
  setActiveCategory: () => {},
});

export function ActiveEquipmentCategoryProvider({ children }) {
  const [activeCategory, setActiveCategory] = useState(null);
  const value = useMemo(
    () => ({ activeCategory, setActiveCategory }),
    [activeCategory]
  );

  return (
    <ActiveEquipmentCategoryContext.Provider value={value}>
      {children}
    </ActiveEquipmentCategoryContext.Provider>
  );
}

export function useActiveEquipmentCategory() {
  return useContext(ActiveEquipmentCategoryContext);
}
